import React from 'react'
import {
  Row,
  Col
} from 'react-bootstrap'
import PageUnderConstructionPlaceholderComponent from '../components/PageUnderConstructionPlaceholderComponent'

const UserInvoicesView = () => {
  return (
    <Row>
      <Col>
        <PageUnderConstructionPlaceholderComponent />
      </Col>
      <Col />
    </Row>
  )
}

export default UserInvoicesView
